<template>
  <div class="template-form-compact">
    <div class="form-section">
      <h6 class="section-title">Параметри вирізу</h6>
      <div class="input-grid">
        <div class="input-group">
          <label for="p1">Розташування</label>
          <select id="p1" :class="{ 'red': detailValidation('P1_') }" v-model.number="detail.p1">
            <option value="0">За довжиною</option>
            <option value="1">За шириною</option>
          </select>
          <div v-if="detailValidation('P1_')" class="error-message">
            {{ detailValidationText('P1_') }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-section-full">
      <div class="input-group">
        <label for="edge_template">Оклеювання кромкою</label>
        <select id="edge_template" class="custom-select edge" :style="getEdgeSelectStyle(detail.edge_template)"
          :class="{ 'red': detailValidation('EdgeA1_') }" v-model="detail.edge_template">
          <option :value="null">Ні</option>
          <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
            {{ (i + 1) + ' ' }} {{ edge.full_name }}
          </option>
        </select>
        <div v-if="detailValidation('EdgeA1_')" class="error-message">
          {{ detailValidationText('EdgeA1_') }}
        </div>
      </div>

      <div class="input-group">
        <label for="note">Примітка</label>
        <input id="note" v-model="detail.note" placeholder="Введіть примітку..." />
      </div>
    </div>
  </div>
</template>

<script>
import validation from "@/mixins/BaseTemplate"

export default {
  mixins: [validation],
  props: [
    'edges',
    'detail'
  ],
  computed: {
    resp() {
      return this.$store.state.data.response;
    },
  },
  watch: {
    detail: function () {
      this.$root.$emit('update-detail', this.detail);
    }
  },
  methods: {
    getEdgeSelectStyle(edgeRef) {
      const edge = this.edges.find(m => m.ref === edgeRef);
      if (edge && edge.color) {
        const contrastColor = this.getContrastColor(edge.color);
        return {
          backgroundColor: edge.color,
          color: contrastColor,
          borderColor: contrastColor,
        };
      }
      return {};
    },
    getContrastColor(hexColor) {
      if (!hexColor) return '#000000';
      const hex = hexColor.replace('#', '');
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? '#000000' : '#ffffff';
    }
  },
  name: "Template_9"
}
</script>

<style scoped>
/* All styles moved to src/assets/scss/general/templates.scss */
</style>
